import React from "react";
import {TextField} from "@mui/material";
import {forms, objects, strings, validation} from "@atttomyx/shared-utils";

const LabeledPhoneForm = (props) => {
    const { data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = strings.isNotBlank(modified.label)
            && strings.isNotBlank(modified.value)
            && validation.validPhone(modified.value);

        onSync(modified);
    }

    return <div className="labeled-phone-form">
        <div className="field">
            <TextField
                label="Label"
                type="text"
                value={forms.sanitizeValue(data.label)}
                onChange={(event) => onChange("label", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Phone"
                type="tel"
                value={forms.sanitizeValue(data.value)}
                error={!validation.validPhone(data.value)}
                onChange={(event) => onChange("value", event.target.value)}
            />
        </div>
    </div>

};

export default LabeledPhoneForm;
